import Lottie from 'lottie-react';
import LoadingAnimation from '../assets/funny-animation.json';

function Arrow() {
    return (
        <div className={`flex items-start`}>
            <svg
                className='w-auto h-16 text-blue-600 rotate-180 transform scale-x-[-1]'
                viewBox='0 0 83 64'
                fill='currentColor'
                xmlns='http://www.w3.org/2000/svg'>
                <path d='M4.27758 62.7565C4.52847 63.5461 5.37189 63.9827 6.16141 63.7318L19.0274 59.6434C19.817 59.3925 20.2536 58.5491 20.0027 57.7595C19.7518 56.97 18.9084 56.5334 18.1189 56.7842L6.68242 60.4184L3.04824 48.982C2.79735 48.1924 1.95394 47.7558 1.16441 48.0067C0.374889 48.2576 -0.0617613 49.101 0.189127 49.8905L4.27758 62.7565ZM13.4871 47.8215L12.229 47.0047L13.4871 47.8215ZM39.0978 20.5925L38.1792 19.4067L39.0978 20.5925ZM7.03921 62.9919C8.03518 61.0681 13.1417 51.1083 14.7453 48.6383L12.229 47.0047C10.5197 49.6376 5.30689 59.8127 4.37507 61.6126L7.03921 62.9919ZM14.7453 48.6383C22.0755 37.3475 29.8244 29.6738 40.0164 21.7784L38.1792 19.4067C27.7862 27.4579 19.7827 35.3698 12.229 47.0047L14.7453 48.6383ZM40.0164 21.7784C52.6582 11.9851 67.634 7.57932 82.2576 3.44342L81.4412 0.556653C66.8756 4.67614 51.3456 9.20709 38.1792 19.4067L40.0164 21.7784Z' />
            </svg>
        </div>
    );
}

export function Placeholder() {
    return (
        <div className='flex h-full w-full items-start justify-center'>
            <div className='max-w-md flex flex-col items-center px-4 py-2'>
                <div className='flex flex-col items-start justify-center'>
                    <Arrow />
                    <span className='ml-24'>
                        Pick a Prompt Template: We’ve got over 60 templates made
                        just for you to use with Word, Outlook, Teams, and other
                        Office apps.
                    </span>
                </div>
                <div className='max-w-[256px] m-[-50px]'>
                    <Lottie animationData={LoadingAnimation} />
                </div>
            </div>
        </div>
    );
}
